/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_DashboardInputs */

const en_marketing_dashboard = /** @type {(inputs: Marketing_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const es_marketing_dashboard = /** @type {(inputs: Marketing_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel`)
};

const fr_marketing_dashboard = /** @type {(inputs: Marketing_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Marketing_DashboardInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_dashboard = /** @type {((inputs?: Marketing_DashboardInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_DashboardInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_dashboard(inputs)
	if (locale === "es") return es_marketing_dashboard(inputs)
	return fr_marketing_dashboard(inputs)
});